import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DatePicker, DefaultButton, Panel, PrimaryButton, Stack} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import {dbDate} from "../../Utilities/dbDate";

function ScheduleProjectAddon(props) {
    const [user] = useContext(AuthContext);
    const [date, setDate] = useState(null);

    const _submit = (e) => {
        e.preventDefault();
        const data = {schedule: dbDate(date)};
        fetch(`/api/addon/${props.add}/schedule`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    useEffect(() => {
        setDate(null);
    }, [props.add])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='ScheduleProjectAddon'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Zaplanuj dodatek"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='ScheduleProjectAddon'>
                <DatePicker
                    label="Plan wykonania"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                />
            </form>
        </Panel>
    )
}

export default ScheduleProjectAddon;